import * as angular from 'angular';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import PDFComponent from './convo_pdf_component';

angular.module('bb.external').component('bbViewMessageExport', {
  bindings: {},
  controller: DownloadPDFCtrl,
  controllerAs: 'vm',
  template: "<div id='content'></div>",
});

DownloadPDFCtrl.$inject = ['$location'];

function DownloadPDFCtrl($location) {
  ReactDOM.render(
    <PDFComponent reportId={$location.search().reportId} />,
    document.getElementById('content'),
  );
}
